export enum ViewTypes {
  AzureExchangeRate = 'azure',
  DefaultExchangeRate = 'default',
}
